export enum SettingScreen {
  Account = 'account',
  ProfileDirectory = 'profile_directory',
  MembershipCard = 'membership_card',
  Notifications = 'notifications',
  DangerZone = 'danger_zone',
  Members = 'members',
  Billing = 'billing',
  General = 'general',
  Styles = 'styles',
  Security = 'security',
  Integrations = 'integrations',
  Properties = 'properties',
}
